






















import {
  defineComponent,
  ref,
  computed
} from '@vue/composition-api'

import ServiceProviderSelector from './ServiceProviderSelector.vue'
import OfferOptions from './OfferOptions.vue'
import DeliveryDetails from './DeliveryDetails.vue'

import { getAreaInfo } from '@/store/modules/area.store'
import {
  getOffers,
  getSelectedOfferId,
  setSelectedAlternativeDelivery,
  setSelectedOfferId
} from '@/store/modules/order-flow.store'

import { isAreaTypeUpsell } from '@/utils/area.utils'
import {
  operatorChangeDateOptions
} from '@/utils/date.utils'

import { OfferOption } from '@/types/area-response.types'

const getAvailableServiceProviders = (offers: OfferOption[]): string[] => {
  return offers
    .map((offer) => offer.ServiceProviderName)
    .filter((serviceProvider: string, index: number, serviceProviderNames: string[]) => {
      return serviceProviderNames.indexOf(serviceProvider) === index
    })
}

const otherServiceProvidersAvailable = (serviceProviders: Readonly<string[]>): boolean => {
  const includesInternalServiceProvider = () => serviceProviders.includes('Telia') ||
      serviceProviders.includes('Anslutning valfri tjänsteleverantör')

  return includesInternalServiceProvider() && serviceProviders.length > 2 ||
    !includesInternalServiceProvider() && serviceProviders.length > 1
}

export default defineComponent({
  components: {
    ServiceProviderSelector,
    OfferOptions,
    DeliveryDetails
  },
  setup (_, context) {
    const store = context.root.$store
    const offers = computed(() => getOffers(store))

    const minimumHeight = ref(0)
    const selectedServiceProvider = ref('Telia')

    const sortedOptions = [...offers.value]
    sortedOptions.sort((optionA: OfferOption, optionB: OfferOption) => {
      if (optionA.InstallationOnly === optionB.InstallationOnly) {
        return optionA.DisplayOrder - optionB.DisplayOrder
      }
      if (optionA.InstallationOnly) {
        return 1
      }
      return -1
    })
    const filteredOffers = computed(() => sortedOptions.filter((offer: OfferOption) => offer.ServiceProviderName === selectedServiceProvider.value))

    const areaInfo = computed(() => getAreaInfo(store))

    const availableServiceProviders = computed(() => getAvailableServiceProviders(sortedOptions))
    const showServiceProviderSelector = computed(() => {
      return isAreaTypeUpsell(areaInfo.value.AreaTypeName) && otherServiceProvidersAvailable(availableServiceProviders.value)
    })

    const offerId = computed({
      get: () => getSelectedOfferId(store),
      set: (selectedOfferId: number | null) => {
        setSelectedOfferId(store, selectedOfferId)

        if (!selectedOfferId && selectedOfferId !== 0) {
          setSelectedAlternativeDelivery(store, false)
        }
      }
    })

    const selectOffer = (id: number | null) => offerId.value = id

    const changeServiceProvider = (provider: string) => {
      selectedServiceProvider.value = provider
      selectOffer(null)
    }

    return {
      selectOffer,
      sortedOptions,
      offerId,
      areaInfo,
      minimumHeight,
      availableServiceProviders,
      changeServiceProvider,
      selectedServiceProvider,
      filteredOffers,
      showServiceProviderSelector,
      operatorChangeDateOptions
    }
  }
})
